import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import { visuallyHidden } from '@mui/utils';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, Divider, FormControl, FormHelperText, Grid, InputAdornment, InputLabel, LinearProgress, MenuItem, Select, TextField } from '@mui/material';
import axiosInstance from '../../utils/axiosInstance';
import { activeInactive, createUser, deleteUser, fetchAllUserData } from '../../store/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import UserProfile from '../../pages/auth/UserProfile';
import { useFormik } from "formik";
import * as Yup from "yup"
import { CloseRounded, Visibility, VisibilityOff } from '@mui/icons-material';
import { fetchRoleData, fetchRoleList } from '../../store/roleSlice';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { capitalizeWords, ROWS_PER_PAGE } from '../../utils/constant';
import Loader from '../Common/Loader';
import Confirmation from '../Common/Confirmation';
import CommentDrawer from '../Common/Drawer';
import { NoData } from '../Common/NoData';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

function createData(id, username, email, isActive, role, actions,) {
  return {
    id,
    username,
    email,
    isActive,
    role,
    actions,
  };
}

const UserActions = ({ getUsers, setPage, setProfileModal, user, setSelectedUser }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dispatch = useDispatch()
  const handleDelete = async (uuid) => {
    try {
      dispatch(deleteUser(uuid)).then(() => {
        // setPage(0)
        getUsers()
      })
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <>
      <Grid spacing={4} justifyContent={'flex-end'}>
        <Grid size={8}>
          <Box gap={2} display='flex' className="table-margin">
            <EditOutlinedIcon className='link-color' onClick={() => { setProfileModal(true); setSelectedUser(user) }} />
            <DeleteOutlineOutlinedIcon className='danger-color' onClick={() => {
              setIsOpen(true)
            }} />
          </Box>
          <>
            <Confirmation open={isOpen} setOpen={setIsOpen} msg={"Are you sure you want to delete this user"} yesClick={() => { handleDelete(user.uuid); setIsOpen(false) }} />
          </>
        </Grid>
      </Grid>
    </>
  )
}


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    label: 'User Name',
    numeric: false,
    disablePadding: false,
    id: 'username',
    sortable: true,
  },
  {
    label: 'Email',
    numeric: false,
    disablePadding: false,
    id: 'email',
    sortable: true,
  },
  {
    label: 'Role',
    numeric: false,
    disablePadding: false,
    id: 'groups__name',
    sortable: true,
  },
  {
    label: 'Active',
    numeric: false,
    disablePadding: false,
    id: 'active',
    sortable: false,
  },
  {
    label: 'Actions',
    numeric: false,
    disablePadding: false,
    id: 'actions',
    sortable: false,
  },
];

function EnhancedTableHead(props) {
  const { setOrdering, orderingState, setOrderingState } =
    props;

  const createSortHandler = (property) => (event) => {
    const orderData = orderingState
    const exists = orderData?.find((item) => item.id === property);
    const updated = (() => {

      if (exists) {
        return orderData.map((item) =>
          item.id === property
            ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
            : item
        );
      } else {
        return [...orderData, { id: property, order: "asc" }];
      }
    })();
    setOrderingState(updated)

  };

  React.useEffect(() => {
    const ordering = orderingState.map((item) => {
      return item.order === "asc" ? item.id : "-" + item.id;
    });
    if (ordering?.length) {
      setOrdering(ordering.join(","));
    }

  }, [orderingState]);

  const removeFilter = (property) => {
    const data = orderingState.filter((item) => item.id !== property)
    setOrderingState(data)
  }
  return (
    <TableHead>
      {/* <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            className='font-weight'
            key={headCell.id}
            align={headCell.numeric ? 'left' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sortable ? <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel> :
              <>{headCell.label}</>}
          </TableCell>
        ))}
      </TableRow> */}
      <TableRow>
        {headCells.map((headCell) => {
          const key = headCell.id;
          const sortObj = orderingState.find((item) => item.id === key);
          const isSorted = !!sortObj;
          const sortDirection = sortObj?.order || "asc";

          return (<TableCell
            className="font-weight"
            key={key}
            align={headCell.numeric ? "left" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={isSorted ? sortDirection : false}
          >
            {headCell.sortable ? <TableSortLabel
              active={isSorted}
              direction={sortDirection}
              onClick={createSortHandler(key)}
              color="secondary"
              hideSortIcon={false}
            >
              {headCell.label}
              {isSorted && (
                <Box component="span" sx={visuallyHidden}>
                  {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              )}
              {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
            </TableSortLabel> : headCell.label}
          </TableCell>)
        })}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const { numSelected, getUsers, page, setPage } = props;
  const rolesList = useSelector((state) => state.roleReducer.roleList)
  const [showPassword, setShowPassword] = React.useState(false);

  const validationSchema = Yup.object({
    username: Yup.string()
      .required("Username is required")
      .min(3, "Username must be at least 3 characters")
      .matches(/^\S*$/, "Username should not contain spaces"), // No spaces allowed
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Enter a valid email address"
      ),
    role_id: Yup.string()
      .required("Role is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
      password: "",
      role_id: "",
    },
    enableReinitialize: false,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setOpen(false)
      values.email = values.email.toLowerCase();
      console.log("Form Submitted:", values);
      dispatch(createUser(values)).then((res) => {
        if (page > 0) {
          setPage(0)
        } else {
          getUsers()
        }

      }).catch((err) => {
        console.log("eerr", err);
      })
    },
  });
  React.useEffect(() => {
    dispatch(fetchRoleList())
  }, [])
  const generatePassword = () => {
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+=<>?';
    const length = 12; // Desired password length
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  };


  return (
    <>
      {/* <Dialog
        open={open}
        onClose={() => { setOpen(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent> */}
      <CommentDrawer open={open} setOpen={setOpen} >
        <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }} >
          <Box
            component="form"
            onSubmit={formik.handleSubmit}
          >
            <Typography variant="h6" gutterBottom className="p-3">
              Create
            </Typography>
            <Divider />
            <div className='role-form-scroller px-3'>
              <TextField
                fullWidth
                required
                id="userName"
                name="username"
                label="Username"
                margin="normal"
                variant="outlined"
                value={formik.values.username}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.username && Boolean(formik.errors.username)}
                helperText={formik.touched.username && formik.errors.username}
              />
              <TextField
                fullWidth
                required
                id="email"
                name="email"
                label="Email"
                type="email"
                onChange={(e) => {
                  const lowerCaseEmail = e.target.value.toLowerCase();
                  formik.setFieldValue("email", lowerCaseEmail);
                }}
                margin="normal"
                variant="outlined"
                value={formik.values.email}
                // onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />

              <TextField
                fullWidth
                required
                id="password"
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                margin="normal"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ?  <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl fullWidth className='mt-3'
                error={formik.touched.role_id && Boolean(formik.errors.role_id)}
                required
              >
                <InputLabel id="role">Role</InputLabel>
                <Select
                  labelId="role"
                  id="role"
                  name='role_id'
                  label="Role"
                  value={formik.values.role_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  MenuProps={{
                    PaperProps: {
                      className: "mui-select-menu",
                    }
                  }}
                  endAdornment={
                    formik.values.role_id ? (
                      <IconButton
                        size="small"
                        className='mr-4'
                        onClick={() => {
                          formik.setFieldValue('role_id', '');
                        }}
                        onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                      >
                        <CloseRounded />
                      </IconButton>
                    ) : null
                  }

                >
                   {(!rolesList || rolesList?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Role found.
                                    </MenuItem>
                                )}
                  {rolesList?.length && rolesList?.map((ele) => <MenuItem value={ele.id}>{ele.name}</MenuItem>)}

                </Select>
                {formik.touched.role_id && formik.errors.role_id && (
                  <FormHelperText className='text-danger'>{formik.errors.role_id}</FormHelperText>
                )}

              </FormControl>
            </div>
            <Box className="drawer-footer m-3">
              {/* <Box display="flex" gap={2} justifyContent="flex-end" className="mt-4"> */}
              <Button
                variant="outlined"
                color="primary"
                className='mr-2'
                onClick={() => { setOpen(false) }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
                color="primary"
              >
                {formik.isSubmitting ? "Creating..." : "Create"}
              </Button>
            </Box>
          </Box>
        </Grid>
      </CommentDrawer>
      {/* </DialogContent>
    </Dialog > */}
      <Toolbar
        className='main-list-toolbar'
      >
        <Typography
          className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Users
        </Typography>
        <Tooltip title="Create">
          <Button variant="contained" onClick={() => {
            setOpen(true);
            formik.setFieldValue('password', generatePassword());

            formik.resetForm()
          }}>
            Create User
          </Button>
        </Tooltip>
      </Toolbar>
    </>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable() {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
  const count = useSelector((state) => state.userReducer.count)
  const [queryString, setQueryString] = React.useState("");

  const [profileModal, setProfileModal] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState({});
  const [inactiveDialog, setInactiveDialog] = React.useState(false);
  const allUserData = useSelector((state) => state?.userReducer?.allUserData);
  const loading = useSelector((state) => state?.userReducer?.loading);
  const dispatch = useDispatch()
  const [ordering, setOrdering] = React.useState();
  const [orderingState, setOrderingState] = React.useState([])

  console.log("loading state:", loading);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  let rowData = [];
  const label = { inputProps: { 'aria-label': 'Color switch demo' } };

  React.useEffect(() => {
    if (allUserData?.length) {
      rowData = allUserData.map((ele) => createData(ele.id, ele.username, ele.email, <Switch disabled={loading} {...label} onClick={(e) => {
        // if (ele.is_active) {
        //   setInactiveDialog(true)
        // } else {
        //   activeInactiveUser(ele.uuid)
        // }

        setSelectedUser(ele)
        if (ele?.is_active) {
          setInactiveDialog(true)
        } else {
          dispatch(activeInactive({ id: ele.uuid, is_active: !ele.is_active })).then((res) => {
          }
          ).catch((err) => {
            console.log("error in Active toggle", err);
          })

        }
      }} checked={ele.is_active ? true : false} />, ele?.role?.name, <UserActions getUsers={getUsers} setPage={setPage} setProfileModal={setProfileModal} setSelectedUser={setSelectedUser} user={ele} />))
      setRows(rowData)
    }
  }, [allUserData, loading])

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const visibleRows = React.useMemo(() => {
  //   return [...rows]
  //   // .sort(getComparator(order, orderBy))
  //   // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  // }, [rows]);

  // const activeInactiveUser = (uuid = null) => {
  //   const selected = allUserData.find(ele => ele.uuid === uuid)
  //   console.log("selected", selected, allUserData, uuid);

  //   dispatch(activeInactive({ id: uuid ? uuid : selectedUser.uuid, is_active: !selected.is_active })).then((res) => {
  //     setSelectedUser(selected)
  //   }
  //   ).catch((err) => {
  //     console.log("error in Active toggle", err);
  //   })


  // }


  React.useEffect(() => {
    dispatch(fetchAllUserData(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : ""}`))
    setQueryString(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : ""}`)
  }, [ordering, page, rowsPerPage])

  const getUsers = () => {
    dispatch(fetchAllUserData(queryString))
  }


  return (
    <Box className='w-100'>
      <UserProfile {...{ getUsers, page, setPage, profileModal, setProfileModal, isShowRole: true, selectedUser }} />
      <Confirmation open={inactiveDialog} setOpen={setInactiveDialog} msg={"Are you sure you want to inactive user"} yesClick={() => {
        dispatch(activeInactive({ id: selectedUser?.uuid, is_active: !selectedUser.is_active })).then((res) => {
        })
        setInactiveDialog(false)
      }} />
      <Paper className="w-100 mb-2" >
        <EnhancedTableToolbar {...{ getUsers, page, setPage }} numSelected={selected.length} />
        {loading && <LinearProgress />}
        <TableContainer className='position-relative'>
          <Table
            aria-labelledby="tableTitle"
            size={'small'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              orderingState={orderingState}
              setOrderingState={setOrderingState}
              setOrdering={setOrdering}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {rows.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    hover
                    onClick={(event) => setSelectedUser(allUserData.find(ele => ele.id === row.id))}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    className='cursor-pointer'
                  >
                    <TableCell
                      align="left"
                      component="th"
                      id={labelId}
                      scope="row"
                    >
                      {capitalizeWords(row.username || "N/A")}
                    </TableCell>
                    <TableCell align="left">{row.email || "N/A"}</TableCell>
                    <TableCell align="left">{row.role || "N/A"}</TableCell>
                    <TableCell align="left">{row.isActive}</TableCell>
                    <TableCell align="left">{row.actions}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {!allUserData?.length && !loading && <NoData></NoData>}
          {/* {!visibleRows && <Loader className='table-loader' />} */}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
